import { Controller } from '@hotwired/stimulus'

class TimerController extends Controller {
  static values = {
    endTimestampSeconds: Number,
    data: Object,
  }

  connect() {
    if (this.endTimestampSecondsValue <= 0) {
      this.element.textContent = '00:00'
      return
    }

    this.setTimeLeft()
    this.intervalId = setInterval(() => {
      this.setTimeLeft()
      if (this.timeLeftSeconds <= 0) {
        this.element.dispatchEvent(new CustomEvent('timer:expired', {
          detail: { data: this.dataValue || {} },
          bubbles: true,
        }))
        clearInterval(this.intervalId)
      }
    }, 1000)
  }

  setTimeLeft() {
    this.timeLeftSeconds = Math.max(
      this.endTimestampSecondsValue - Math.floor(Date.now() / 1000),
      0,
    )
    this.element.textContent = this.formattedTime()
  }

  formattedTime() {
    const minutes = Math.floor(this.timeLeftSeconds / 60)
    const remainingSeconds = this.timeLeftSeconds % 60
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
  }

  disconnect() {
    if (this.intervalId) clearInterval(this.intervalId)
  }
}

export default TimerController
